const REI_ITEM_TYPE = {
  BOOLEAN: 'BOOLEAN',
  INTEGER: 'INTEGER',
  STRING: 'STRING',
};

export {REI_ITEM_TYPE};
